import {
  DIAGNOSIS_ISSUE_CHECK,
  DIAGNOSIS_ISSUE_CHECK_FINISHED
} from './actions.js'

export default function reducer (state = { diagnosisCheck: false }, action) {
  switch (action.type) {
    case DIAGNOSIS_ISSUE_CHECK:
      return {
        ...state,
        diagnosisCheck: true
      }
    case DIAGNOSIS_ISSUE_CHECK_FINISHED:
      return {
        ...state,
        diagnosisCheck: false
      }
    default:
      return state
  }
}
